import { EquipmentManufacturerData } from '@models/interfaces';

export const EQUIPMENT_MANUFACTURER_DEFAULT_VALUE: EquipmentManufacturerData = {
  id: '',
  name: '',
  equipmentTypes: [],
};
